import { Injectable } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';

@Injectable()
export class StateStorageService {
    constructor(
        private $sessionStorage: SessionStorageService
    ) { }

    getPreviousState() {
        return this.$sessionStorage.retrieve('previousState');
    }

    resetPreviousState() {
        this.$sessionStorage.clear('previousState');
    }

    storePreviousState(previousStateName, previousStateParams) {
        let previousState = { 'name': previousStateName, 'params': previousStateParams };
        this.$sessionStorage.store('previousState', previousState);
    }

    getDestinationState() {
        return this.$sessionStorage.retrieve('destinationState');
    }

    storeDestinationState(destinationState, destinationStateParams, fromState) {
        let destinationInfo = {
            'destination': {
                'name': destinationState.name,
                'data': destinationState.data,
            },
            'params': destinationStateParams,
            'from': {
                'name': fromState.name,
            }
        };
        this.$sessionStorage.store('destinationState', destinationInfo);
    }

    setCurrentTimezone(tz: String) {
        this.$sessionStorage.store('timezone', tz);
    }

    getCurrentTimezone() {
        return  this.$sessionStorage.retrieve('timezone') ;
    }

    deleteCurrentTimezone() {
        this.$sessionStorage.clear('timezone') ;
    }

    setAccountLabel(label: String) {
        this.$sessionStorage.store('accountLabel', label);
    }

    getAccountLabel() {
        return  this.$sessionStorage.retrieve('accountLabel') ;
    }

    deleteAccountLabel() {
        this.$sessionStorage.clear('accountLabel');
    }

    setCurrentTenantName(name: String) {
        this.$sessionStorage.store('currentTenantName', name);
    }

    getCurrentTenantName() {
        return this.$sessionStorage.retrieve('currentTenantName');
    }

    deleteCurrentTenantName() {
        this.$sessionStorage.clear('currentTenantName');
    }

    setNavbarColor(color: String) {
        this.$sessionStorage.store('navbarColor', color);
    }

    getNavbarColor() {
        return this.$sessionStorage.retrieve('navbarColor');
    }

    deleteNavbarColor() {
        this.$sessionStorage.clear('navbarColor');
    }

    setFooterColor(color: String) {
        this.$sessionStorage.store('footerColor', color);
    }

    getFooterColor() {
        return this.$sessionStorage.retrieve('footerColor');
    }

    deleteFooterColor() {
        this.$sessionStorage.clear('footerColor');
    }

    setBackgroundColor(color: String) {
        this.$sessionStorage.store('BackgroundColor', color);
    }

    getBackgroundColor() {
        return this.$sessionStorage.retrieve('BackgroundColor');
    }

    deleteBackgroundColor() {
        this.$sessionStorage.clear('BackgroundColor');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/auth/state-storage.service.ts